import type { ReactNode } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

interface SiteLayoutProps {
  children: ReactNode;
  /** Home page lets the hero sit under the transparent navbar */
  flushTop?: boolean;
}

export default function SiteLayout({ children, flushTop = false }: SiteLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-background-950">
      <Navbar />
      <main className={`flex-1 ${flushTop ? '' : 'pt-16 md:pt-20'}`}>{children}</main>
      <Footer />
    </div>
  );
}